import Head from 'next/head';
import Image from 'next/image';
import React from 'react';

import { pageTitle } from '../../components/shared/basic/customHead';
import HeadingV2 from '../../components/shared/HeadingV2';
import { ArrowFaq, Author } from '../../../assets';

const Pdf: React.FC = () => {
  return (
    <div className='app'>
      <Head>
        <title>{pageTitle('PDF Reader')}</title>
      </Head>
      <div className='relative overflow-hidden'>
        <div className='px-5 md:px-10 lg:px-24 py-14 flex flex-col gap-y-10'>
          <span>
            <HeadingV2 heading='The Industry Handbook ' />
          </span>
          <span>
            <div className='flex gap-x-4 items-center text-sm'>
              <span className=''>
                <Image
                  src={Author}
                  alt='Author'
                  className='object-contain z-0 rounded-full '
                />
              </span>
              <span className='flex flex-col'>
                <span className='font-medium text-sm'>Ashwinder R. Singh</span>
              </span>
            </div>
          </span>
        </div>

        <span className='flex justify-end w-full absolute top-28s xl:top-[5%]  translate-x-12'>
          <span className='w-36 md:w-44 lg:w-60 '>
            <Image src={ArrowFaq} alt='ArrowFaq' />
          </span>
        </span>
      </div>
    </div>
  );
};

export default Pdf;
